"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[429],{

/***/ 9295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CustomHit": function() { return /* binding */ CustomHit; },
  "CustomHits": function() { return /* binding */ CustomHits; },
  "SearchWidget": function() { return /* binding */ SearchWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectSearchBox.js
var connectSearchBox = __webpack_require__(4575);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/PoweredBy.js + 4 modules
var PoweredBy = __webpack_require__(114);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectHits.js
var connectHits = __webpack_require__(8810);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectHitInsights.js
var connectHitInsights = __webpack_require__(4717);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(4793);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/Configure.js + 1 modules
var Configure = __webpack_require__(4859);
// EXTERNAL MODULE: ./hooks/useBodyFix.tsx
var useBodyFix = __webpack_require__(7052);
;// CONCATENATED MODULE: ./hooks/useOnClickOutside.tsx

const useOnClickOutside = (ref, handler)=>{
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ok
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
};

;// CONCATENATED MODULE: ./utils/fingerprint.ts
function getFingerprint() {
    const w = window;
    const f = w.localStorage.getItem("typeofweb_s") || generate();
    w.localStorage.setItem("typeofweb_s", f);
    return f;
}
function generate() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char)=>{
        const random = Math.random() * 16 | 0;
        const value = char === "x" ? random : random & 3 | 8;
        return value.toString(16);
    });
}

// EXTERNAL MODULE: ./utils/permalinks.ts
var permalinks = __webpack_require__(4807);
// EXTERNAL MODULE: ./components/atoms/ArticleCoverImage.tsx
var ArticleCoverImage = __webpack_require__(9655);
// EXTERNAL MODULE: ./components/atoms/Input.tsx
var Input = __webpack_require__(2544);
;// CONCATENATED MODULE: ./components/molecules/SearchWidget.tsx













const searchClient = algoliasearch_lite_umd_default()("QB2FWHH99M", "25fc15b3e367b7a46c1f3617b39aa749", {
    headers: {
        "x-algolia-usertoken": getFingerprint()
    }
});
const SearchWidget = /*#__PURE__*/ (0,react.memo)(()=>{
    const IS_MAC =  true && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
    const { events  } = (0,router.useRouter)();
    const toggleSearch = (0,react.useCallback)(()=>{
        setIsOpen((v)=>!v);
    }, []);
    const openSearch = (0,react.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const closeSearch = (0,react.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    (0,react.useEffect)(()=>{
        events.on("routeChangeStart", closeSearch);
        return ()=>events.off("routeChangeStart", closeSearch);
    }, [
        events,
        closeSearch
    ]);
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const handler = (event)=>{
            const isEsc = event.key === "Escape";
            const isK = event.key === "k";
            const isSlash = event.key === "/";
            const isMeta = IS_MAC ? event.metaKey : event.ctrlKey;
            if ((isK && isMeta || isSlash) && !event.altKey && !event.shiftKey) {
                toggleSearch();
                event.preventDefault();
            } else if (isEsc) {
                if (isOpen) {
                    event.preventDefault();
                    closeSearch();
                }
            }
        };
        document.addEventListener("keydown", handler);
        return ()=>{
            document.removeEventListener("keydown", handler);
        };
    }, [
        IS_MAC,
        closeSearch,
        toggleSearch,
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal, {
                onCancel: closeSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Szukaj na stronie…",
                className: "flex flex-row items-center justify-between px-5 w-full h-11 bg-gradient-to-b focus:border-blue-200 border-gray-300 rounded-lg hover:shadow-lg focus:shadow-lg shadow-md from-white to-gray-100 transition-shadow focus:ring focus:ring-blue-100 focus:ring-opacity-50 focus:ring-offset-2 lg:h-12",
                title: "Szukaj…",
                type: "button",
                onClick: openSearch,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "animate-delay-0 flex flex-row gap-3 items-baseline mt-1 w-full text-gray-600 animate-appear",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                viewBox: "0 0 20 20",
                                fill: "currentColor",
                                className: "h-4 fill-current opacity-75",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M19.71,18.29,16,14.61A9,9,0,1,0,14.61,16l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,19.71,18.29ZM2,9a7,7,0,1,1,12,4.93h0s0,0,0,0A7,7,0,0,1,2,9Z"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Szukaj",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only md:not-sr-only",
                                        children: " na stronie"
                                    }),
                                    "…"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "animate-delay-0 hidden animate-appear md:flex md:flex-grow-0 md:gap-2 md:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("kbd", {
                                className: "shadow-darker block text-gray-600 bg-gradient-to-tl border-b-2 border-gray-300 rounded from-gray-100 to-gray-200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: `inline-flex items-center justify-center p-2 h-7  leading-none border-l border-r border-t border-white rounded ${IS_MAC ? "text-lg" : "text-base"}`,
                                    children: IS_MAC ? "⌘" : "ctrl"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("kbd", {
                                className: "shadow-darker block text-gray-600 bg-gradient-to-tl border-b-2 border-gray-300 rounded from-gray-100 to-gray-200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-flex items-center justify-center p-2 h-7 leading-none border-l border-r border-t border-white rounded",
                                    children: "K"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
SearchWidget.displayName = "SearchWidget";
const InBody = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ react_dom.createPortal(children, document.body);
};
const CustomSearchBox = (0,connectSearchBox/* default */.Z)((param)=>{
    let { refine , currentRefinement , currentObjectID , onChange  } = param;
    const handleCustomSearchBoxKeyDown = (0,react.useCallback)((e)=>{
        if (currentRefinement && e.key === "Escape") {
            e.stopPropagation();
            refine("");
        } else if (e.key === "Enter") {
            e.preventDefault();
        }
    }, [
        currentRefinement,
        refine
    ]);
    const handleChange = (0,react.useCallback)((e)=>{
        refine(e.currentTarget.value);
        onChange(e.currentTarget.value);
    }, [
        onChange,
        refine
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: "relative flex items-center w-full max-h-screen",
        noValidate: true,
        role: "search",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Input/* Input */.I, {
            onKeyDown: handleCustomSearchBoxKeyDown,
            className: "flex-1 mt-0 pl-8 w-full h-10 text-base border-transparent shadow-none sm:h-14 sm:text-3xl lg:pl-16 lg:h-20",
            "aria-autocomplete": "list",
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: false,
            placeholder: "Szukaj na stronie…",
            maxLength: 512,
            type: "search",
            enterKeyHint: "go",
            value: currentRefinement,
            onChange: handleChange,
            autoFocus: true,
            "aria-controls": "search-hits-list",
            ...currentObjectID && {
                "aria-activedescendant": "id" + currentObjectID
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    viewBox: "0 0 20 20",
                    fill: "currentColor",
                    className: "absolute z-10 left-3 top-1/2 py-1 h-6 text-gray-700 -translate-y-1/2 lg:left-6 lg:h-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.71,18.29,16,14.61A9,9,0,1,0,14.61,16l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,19.71,18.29ZM2,9a7,7,0,1,1,12,4.93h0s0,0,0,0A7,7,0,0,1,2,9Z"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:rigth-3 absolute z-10 right-1 top-1/2 -translate-y-1/2 lg:right-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PoweredBy/* default */.Z, {})
                })
            ]
        })
    });
});
CustomSearchBox.displayName = "CustomSearchBox";
const CustomHits = (0,connectHits/* default */.Z)((param)=>{
    let { hits , currentObjectID , setObjectId  } = param;
    const { push  } = (0,router.useRouter)();
    const currentHitIndex = hits.findIndex((h)=>h.objectID === currentObjectID);
    const currentHit = hits.find((h)=>h.objectID === currentObjectID);
    const selectNextHit = (0,react.useCallback)(()=>{
        const nextHitIndex = (currentHitIndex + 1) % hits.length;
        const nextHit = hits[nextHitIndex];
        setObjectId(nextHit.objectID);
    }, [
        currentHitIndex,
        hits,
        setObjectId
    ]);
    const selectPrevHit = (0,react.useCallback)(()=>{
        const prevHitIndex = (currentHitIndex - 1 + hits.length) % hits.length;
        const prevHit = hits[prevHitIndex];
        setObjectId(prevHit.objectID);
    }, [
        currentHitIndex,
        hits,
        setObjectId
    ]);
    (0,react.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === "ArrowUp") {
                event.preventDefault();
                selectPrevHit();
            } else if (event.key === "ArrowDown") {
                event.preventDefault();
                selectNextHit();
            } else if (event.key === "Enter" && currentHit?.objectID) {
                event.preventDefault();
                window.aa("clickedObjectIDsAfterSearch", {
                    index: "typeofweb_prod",
                    eventName: "Search result [Enter]",
                    objectIDs: [
                        currentHit.objectID
                    ],
                    positions: [
                        currentHit.__position
                    ],
                    queryID: currentHit.__queryID
                });
                void push((0,permalinks/* getUrlForPermalink */.U)(currentHit.objectID));
            }
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        selectNextHit,
        selectPrevHit,
        push,
        currentHit?.objectID,
        currentHit?.__position,
        currentHit?.__queryID
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:h-[50vh] flex flex-row max-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                id: "search-hits-list",
                className: "overflow-scrolling-touch mt-1 pb-32 w-full overflow-y-auto lg:w-1/2",
                "aria-controls": "search-details",
                children: hits.map((hit)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        role: "option",
                        "aria-describedby": "search-details",
                        "aria-selected": currentHit?.objectID === hit.objectID ? "true" : "false",
                        id: "id" + hit.objectID,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHit, {
                            hit: hit,
                            onItemHover: setObjectId,
                            currentObjectID: currentHit?.objectID
                        })
                    }, hit.objectID))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:overflow-scrolling-touch hidden lg:block lg:mt-1 lg:px-8 lg:py-6 lg:w-1/2 lg:overflow-y-auto",
                "aria-atomic": true,
                "aria-live": "polite",
                role: "region",
                id: "search-details",
                children: currentHit && /*#__PURE__*/ (0,jsx_runtime.jsx)(HitDetails, {
                    currentHit: currentHit
                })
            })
        ]
    });
});
CustomHits.displayName = "CustomHits";
const HitDetails = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { currentHit  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-gray-900 text-xl font-bold",
                children: currentHit.title || ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-1 text-gray-600 text-sm",
                children: [
                    currentHit.category?.name || "",
                    " ",
                    currentHit.series ? `> ${currentHit.series.name}` : ""
                ]
            }),
            currentHit.img && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCoverImage/* ArticleCoverImage */.p, {
                cover: {
                    blurDataURL: null,
                    img: {
                        width: currentHit.img.width,
                        height: currentHit.img.height,
                        src: currentHit.img.url
                    },
                    preload: false
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-3 text-gray-900",
                children: currentHit.excerpt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: (0,permalinks/* getUrlForPermalink */.U)(currentHit.objectID),
                className: "inline-block mt-5 px-4 py-2 text-gray-100 text-2xl focus:bg-green-600 bg-green-700 rounded-md outline-none cursor-pointer transition-all focus:ring focus:ring-blue-100 focus:ring-opacity-50 focus:ring-offset-2",
                children: "Idź do artykułu"
            })
        ]
    });
}, (prev, next)=>prev.currentHit.objectID === next.currentHit.objectID);
HitDetails.displayName = "HitDetails";
const _CustomHit = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { hit , insights , onItemHover , currentObjectID  } = param;
    const isActive = currentObjectID === hit.objectID;
    const currentElRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        if (isActive) {
            currentElRef.current?.scrollIntoView({
                behavior: "auto",
                block: "nearest",
                inline: "nearest"
            });
        }
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: (0,permalinks/* getUrlForPermalink */.U)(hit.objectID),
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            ref: currentElRef,
            onMouseEnter: ()=>onItemHover(hit.objectID),
            onFocus: ()=>onItemHover(hit.objectID),
            onPointerEnter: ()=>onItemHover(hit.objectID),
            className: `relative flex flex-col pl-4 pr-12 py-1 border-b last:border-b-0 focus:no-underline ${isActive ? "bg-green-600 shadow-md" : ""}`,
            title: hit.title,
            onClick: ()=>insights("clickedObjectIDsAfterSearch", {
                    eventName: "Search result clicked",
                    objectIDs: [
                        hit.objectID
                    ],
                    positions: [
                        hit.__position
                    ],
                    queryID: hit.__queryID
                }),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    className: `absolute right-4 top-1/2 block w-6 h-auto -translate-y-1/2 ${isActive ? "block text-gray-100" : "hidden"}`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                            points: "9 10 4 15 9 20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M20 4v7a4 4 0 0 1-4 4H4"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: `block whitespace-nowrap text-lg overflow-hidden text-ellipsis ${isActive ? "text-gray-100" : "text-gray-900"}`,
                    children: hit.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: `block whitespace-nowrap text-sm overflow-hidden text-ellipsis ${isActive ? "text-gray-200" : "text-gray-700"}`,
                    children: [
                        hit.category?.name || "",
                        " ",
                        hit.series ? `> ${hit.series.name}` : ""
                    ]
                })
            ]
        })
    });
}, (prev, next)=>prev.hit.objectID === next.hit.objectID && prev.currentObjectID === next.currentObjectID);
_CustomHit.displayName = "AlogliaHit";
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ok
const CustomHit = (0,connectHitInsights/* default */.Z)(window.aa)(_CustomHit);
CustomHit.displayName = "AlogliaHit";
const SearchModal = (param)=>{
    let { onCancel  } = param;
    const [currentObjectID, setObjectId] = (0,react.useState)(null);
    const searchModalRef = (0,react.useRef)(null);
    const bodyFix = (0,useBodyFix/* useBodyFix */.s)();
    useOnClickOutside(searchModalRef, onCancel);
    (0,react.useEffect)(()=>{
        bodyFix.fixBody();
        return ()=>{
            bodyFix.unfixBody();
        };
    }, [
        bodyFix
    ]);
    const handleInputChange = (0,react.useCallback)(()=>{
        setTimeout(()=>setObjectId(null), 0);
    }, []);
    (0,react.useEffect)(()=>{
        // @ts-ignore
        window.aa("init", {
            appId: "QB2FWHH99M",
            apiKey: "25fc15b3e367b7a46c1f3617b39aa749"
        });
        // @ts-ignore
        window.aa("setUserToken", getFingerprint());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InBody, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: "typeofweb_prod",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Configure/* default */.Z, {
                    clickAnalytics: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "animate-delay-0 animate-duration-100 lg:pt-[20vh] fixed z-50 inset-0 flex items-start justify-center text-base bg-gray-400 bg-opacity-50 overflow-hidden animate-appear",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: searchModalRef,
                        className: "flex flex-col items-stretch justify-between w-full max-h-screen bg-white shadow-md xl:max-w-5xl xl:rounded-md",
                        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props -- https://www.w3.org/TR/wai-aria-practices-1.1/examples/combobox/aria1.1pattern/listbox-combo.html
                        role: "combobox",
                        "aria-owns": "search-hits-list",
                        "aria-expanded": "true",
                        "aria-haspopup": "listbox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row shadow-md sm:rounded-lg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSearchBox, {
                                        currentObjectID: currentObjectID,
                                        onChange: handleInputChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-0.5 bg-gray-200"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: onCancel,
                                        type: "button",
                                        className: "flex flex-row items-center px-4 text-gray-600 hover:text-gray-800 focus:border-blue-200 border-gray-300 rounded-md transition-shadow focus:ring focus:ring-blue-100 focus:ring-opacity-50 focus:ring-offset-2 lg:px-16",
                                        children: "Anuluj"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHits, {
                                currentObjectID: currentObjectID,
                                setObjectId: setObjectId
                            })
                        ]
                    })
                })
            ]
        })
    });
};
SearchModal.displayName = "SearchModal";


/***/ })

}]);